import {
    useCallback, useMemo,
} from 'react'

import useRequestTable from 'app/hooks/useRequestTable'
import useHasPermission from 'app/hooks/useHasPermission'
import useLabel from 'app/hooks/useLabel'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import RichTableWithAddIcon from 'app/shared-components/RichTableWithAddIcon'

import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import request from 'app/requests/CQuote/CQuote.requests'
import {
    CQuotesTable,
} from '../../CQuotes/CQuotes.types'

import getColumns from './CQuotesByAccount.columns'

export default function CQuotesByAccount({
    id,
}: Readonly<{ id: number }>) {
    const l = useLabel()
    const {
        CQuotes: CQuotesRoutes,
    } = useAccountManagementRoutes()

    const accountCreate = useHasPermission(['account_create_all'])

    const {
        onParamsChange,
        loadData,
    } = useRequestTable<{ data: CQuotesTable[] }>({
        key: RequestKeys.cQuotesFilterRequest,
        params: {},
        defaultValue: {
            filter: {
                pricingAccountId: [id],
            },
        },
        config: request.cQuotesFilterRequest,
        keepPreviousData: true,
        enabled: Boolean(id),
    })

    const openCreateForm = useCallback(() => {
        CQuotesRoutes.Create.navigate({
            params: {
                selectedMethod: 'cquote',
            },
        })
    }, [CQuotesRoutes.Create])

    const onRowClick = useCallback(({
        id: quoteId,
    }: CQuotesTable) => {
        CQuotesRoutes.Overview.navigate({
            params: {
                key: quoteId,
            },
        })
    }, [CQuotesRoutes.Overview])

    const columns = useMemo(() => {
        return getColumns({
            l,
        })
    }, [l])

    return (
        <RichTableWithAddIcon
            title="C-Quotes"
            onOpenForm={openCreateForm}
            name="cquote"
            configName="CQuotesByAccountTable"
            createEnabled={accountCreate}
            loadData={loadData}
            onParamsChange={onParamsChange}
            columns={columns}
            onRowClick={onRowClick}
        />
    )
}
